// extracted by mini-css-extract-plugin
export default {"title":"_--z","warning":"a_-z","sizeOptionsLegendText":"b_-z"};